import styled from 'styled-components'
import { SIZES } from '../../../constants'

export default styled.div`
  display: block;
  position: relative;

  @media (max-width: ${SIZES.BREAKPOINT_XS - 1}px) {
    height: 90px;
  }

  & .video {
    height: 19px;
    left: 14px;
    bottom: 14px;
    font-size: 10px;
    line-height: 16.5px;
    padding: 0 7px 0 17px;

    &::before {
    background-size: 8px 10px;
    height: 10px;
    width: 8px;
    left: 5px;
    top: 3px;
    }
  }

`
